import { IComponentOptions, IController } from 'angular';
import { IGmcInfoNavTab } from './gmc-info-nav-tab.interface';
import './gmc-info-nav-tabs.component.scss';

class GmcInfoNavTabController implements IController {
  public infoTabs: IGmcInfoNavTab[];

  constructor() {

  }
}

export const GmcInfoNavTabComponent: IComponentOptions = {
  controller: GmcInfoNavTabController,
  template: require('./gmc-info-nav-tabs.component.html'),
  bindings: {
    infoTabs: '<'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-tabs/components/gmc-info-nav-tabs/gmc-info-nav-tabs.component.ts